import { app, initializeRecaptchaAppCheck } from '../firebase';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { getToken } from 'firebase/app-check';

let translateCallable = null;
const FUNCTIONS_REGION = 'europe-central2';

const getTranslateCallable = () => {
  if (typeof window === 'undefined') {
    throw new Error('Translation is unavailable in this environment.');
  }

  if (!translateCallable) {
    const functions = getFunctions(app, FUNCTIONS_REGION);
    translateCallable = httpsCallable(functions, 'translatePost');
  }

  return translateCallable;
};

const warmUpAppCheckToken = async () => {
  try {
    const appCheck = await initializeRecaptchaAppCheck();
    if (appCheck) {
      await getToken(appCheck, false);
    }
  } catch (error) {
    // App Check should not block translation; if it's misconfigured,
    // the callable will still work unless enforcement is enabled.
    if (process.env.NODE_ENV === 'development') {
      console.warn('App Check token warm-up failed', error);
    }
  }
};

export async function translateText(text, targetLang) {
  if (!text || !text.trim()) {
    throw new Error('Missing text to translate.');
  }

  await warmUpAppCheckToken();
  const callable = getTranslateCallable();
  const { data } = await callable({ text, targetLang });
  if (!data || typeof data.translatedText !== 'string') {
    throw new Error('Invalid translation response.');
  }
  return data.translatedText;
}
